import { withHandlers } from 'recompose';

export const withRef = withHandlers(() => {
  let containerRef = null;

  return {
    setRef: () => ref => containerRef = ref,
    getRef: () => () => containerRef,
  };
});
